import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SEO from "../../components/SEO";

const PaymentCancelled = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  
  const programTitle = searchParams.get("program_title");
  const type = searchParams.get("type");
  const token = searchParams.get("token");
  const isCourse = type === "course";

  return (
    <>
      <SEO 
        title={`${t("paymentPages.cancelledTitle")} - Internationale in Kunst`}
        description={t("paymentPages.cancelledMessage")}
        noindex
      />
      
      <div className="min-h-screen bg-black text-white flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-gradient-to-b from-black/70 via-zinc-900/80 to-zinc-800/90 rounded-2xl p-8 shadow-2xl border border-white/20 text-center">
          <div className="text-6xl mb-6">❌</div>
          <h1 className="text-3xl font-bold mb-4">{t("paymentPages.cancelledTitle")}</h1>
          <p className="text-gray-300 mb-6">
            {isCourse ? t("paymentPages.courseCancelledMessage") : t("paymentPages.cancelledMessage")}
            {!isCourse && programTitle && (
              <span className="block mt-2">
                <strong>{programTitle}</strong> {t("paymentPages.paymentNotCompleted")}
              </span>
            )}
          </p>

          <div className="space-y-3">
            {isCourse && token ? (
              <>
                <Link
                  to={`/kurs-sozlesmesi/${token}`}
                  className="block w-full bg-[#D8001D] hover:bg-[#B8001A] text-white py-3 px-6 rounded font-semibold transition-colors"
                >
                  {t("paymentPages.continueContract")}
                </Link>
                <Link
                  to="/"
                  className="block w-full bg-gray-700 hover:bg-gray-600 text-white py-3 px-6 rounded font-semibold transition-colors"
                >
                  {t("paymentPages.backToHome")}
                </Link>
              </>
            ) : (
              <>
                <Link
                  to="/"
                  className="block w-full bg-[#D8001D] hover:bg-[#B8001A] text-white py-3 px-6 rounded font-semibold transition-colors"
                >
                  {t("paymentPages.backToHome")}
                </Link>

                <Link
                  to="/program"
                  className="block w-full bg-gray-700 hover:bg-gray-600 text-white py-3 px-6 rounded font-semibold transition-colors"
                >
                  {t("paymentPages.tryAgain")}
                </Link>
              </>
            )}
          </div>
        </div>
      </div>


    </>
  );
};

export default PaymentCancelled; 